import * as React from 'react';
import { attachmentUrl } from '../../config';
import CountryService from '../../services/CountryService';
import { Icon } from '../../modules/modules';

interface IProductFileProps {
  file: GQL.IProductFile;
}

class ProductFile extends React.Component<IProductFileProps> {

  public render() {
    const { file } = this.props;
    const { language } = CountryService.GetInstance();
    let fileName: string = file.file;
    if (file.file && ((!file.title) || !file.title[language])) {
      const properFileName = file.file.split('/').pop() || ''; // || just to prevent TS errors
      fileName = (properFileName.substring(5, 6) === '_')
        // conditionally, because there are files in database, that do not have the hash prefix
        ? properFileName.substring(properFileName.indexOf('_') + 1)
        : properFileName;
    }

    return (
      <div className="productFile">
        <a href={`${attachmentUrl}/${file.file}`} target="_blank">
          <Icon type="shape" />
          {file.title[language] || fileName || 'data sheet'}
        </a>
      </div>
    );
  }
}

export default ProductFile;


// WEBPACK FOOTER //
// ./src/components/ProductFile/ProductFile.tsx